class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClickHandler.bind(this));
  }

  connectedCallback() {
    if (this.dataset.trigger == 'infinite' && !this.observer) {
      // Start downloading the next page ~1.5 screens early so it is ready when the loader is reached
      this.prefetchObserver = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        this.prefetchObserver.disconnect();
        InfiniteScroll.fetchPage(this.dataset.url).catch(() => {});
      }, {rootMargin: '0px 0px 150% 0px'});
      this.prefetchObserver.observe(this);

      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'});
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.prefetchObserver) this.prefetchObserver.disconnect();
  }

  onClickHandler() {
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;
    this.classList.add('loading');
    this.classList.add('disabled');

    InfiniteScroll.renderSectionFromFetch(this.dataset.url, this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.onClickHandler();
  }

  // One request per page (shared by the early prefetch and the loader). Only the product grid
  // section is requested (Section Rendering API), not the whole page, so it arrives much faster.
  static fetchPage(url) {
    if (!InfiniteScroll.pages.has(url)) {
      const grid = document.getElementById('product-grid');
      const requestUrl = new URL(url, window.location.origin);
      if (grid && grid.dataset.id) requestUrl.searchParams.set('section_id', grid.dataset.id);

      InfiniteScroll.pages.set(url, fetch(requestUrl)
        .then(response => {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .catch((e) => {
          InfiniteScroll.pages.delete(url); // allow a retry
          throw e;
        }));
    }
    return InfiniteScroll.pages.get(url);
  }

  static renderSectionFromFetch(url, trigger) {
    InfiniteScroll.fetchPage(url)
      .then((html) => {
        InfiniteScroll.pages.delete(url);
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.getElementById('product-grid');
        const grid = document.getElementById('product-grid');
        if (!newGrid || !grid) throw new Error('product-grid missing in response');

        // Products first, then the next trigger (removed when there are no more pages)
        grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
        InfiniteScroll.renderPagination(doc);
      })
      .catch((e) => {
        console.error(e);
        // Stop the loader; no automatic retry loop
        trigger.classList.remove('loading', 'disabled');
      });
  }

  static renderPagination(doc) {
    const container = document.getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    if (!container) return;
    const newContainer = doc.getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    if (newContainer && newContainer.querySelector('infinite-scroll')) {
      container.innerHTML = newContainer.innerHTML;
    } else {
      container.remove();
    }
  }
}
InfiniteScroll.pages = new Map();
customElements.define('infinite-scroll', InfiniteScroll);
